import { FeedbackFormData } from '../../../feedback-form/feedback-types';

export const generalFormData: FeedbackFormData = {
  id: 'general',
  title: '',
  subtitle: '',
  questions: [
    [
      {
        id: 'anything-else',
        title: $localize`Innovate with us`,
        subtitle: $localize`We invite you to share your ideas with us. Please take a few moments to let us know what you like, dislike, and if you have any new ideas for us to explore.`,
        type: 'textarea',
      },
      {
        id: 'email',
        title: $localize`E-mail contact`,
        subtitle: $localize`In case we need more information, we would like to contact you on the e-mail address you gave us when signing up.`,
        type: 'consent',
        options: [
          {
            id: 'mail',
            label: $localize`By ticking this box you allow us to get in contact with you by e-mail.`,
          },
        ],
      },
    ],
  ],
};
